(function () {
  'use strict';

  angular
    .module('app.user-switcher')
    .controller('UserSwitcherController', UserSwitcherController);

  UserSwitcherController.$inject = ['$rootScope', '$scope', '$api', '$state', '$translate', '$window', 'ngDialog'];

  function UserSwitcherController($rootScope, $scope, $api, $state, $translate, $window, ngDialog) {
    var vm = this;

    vm.users = [];
    vm.init = false;
    vm.loading = false;

    vm.switchUser = function (user) {
      if ($rootScope.appConfig.user.switchable) {
        $api.post({
          path: '/api/switch_user',
          data: {
            new_user_id: user.id
          }
        }).then(function (response) {
          if (response.status) {
            $rootScope.getAppConfig().then(function () {
              $state.go('app.page-order-tasks');
              $rootScope.activeTableConfig.getData();
            });
          }
        });
      } else {
        $state.go('app.page-order-tasks', {
          filters: [{
            name: $translate.instant('User') + ': ' + user.name,
            attr: 'user_id',
            value: user.id
          }]
        });
      }

      $rootScope.app.offsidebarOpen = false;
    };

    vm.getData = function () {
      vm.loading = true;

      $api.getAll({
        model: 'user',
        data: {
          where: [
            ['active', '=', true],
            ['switchable', '=', true]
          ],
          getAttrs: ['started_order_tasks_quantity', 'available_order_tasks_quantity'],
          pagination_limit: 1000
        }
      }).then(function (response) {
        $scope.$applyAsync(function () {
          vm.users = response.data.items;

          for (var i = 0; i < vm.users.length; i++) {
            if (vm.users[i].id === $rootScope.appConfig.user.id) {
              // eslint-disable-next-line no-loop-func
              [
                'current_order_task',
                'started_order_tasks_quantity',
                'available_order_tasks_quantity'
              ].forEach(function (item) {
                $rootScope.appConfig.user[item] = vm.users[i][item];
              });
              break;
            }
          }

          vm.loading = false;
        });
      }, function () {
        vm.loading = false;
      });
    };

    if ($rootScope.appConfig) {
      activate();
    } else {
      var getAppConfig = $rootScope.$watch('appConfig', function (value) {
        if (value) {
          activate();
          getAppConfig();
        }
      });
    }

    // //////////////

    function activate() {
      vm.init = true;
      vm.getData();
    }

    // if ($rootScope.socket) {
    //   $rootScope.socket.on('event:App\\Events\\ModelChanged', function (event) {
    //     if (['user', 'workgroup', 'order_task'].indexOf(event.data.data.model) !== -1) {
    //       getData();
    //     }
    //   });
    // }

    $rootScope.toggleUserSwitcher = function () {
      $rootScope.app.offsidebarOpen = !$rootScope.app.offsidebarOpen;
    };

    $rootScope.showPrinterDialog = function () {
      try {
        var dialogScope = $scope.$new(true);

        dialogScope.printers = $rootScope.appConfig.printers || [];
        dialogScope.model = {
          printerId: $window.localStorage.getItem('printerId') || dialogScope.printers[0].id
        };

        ngDialog.openConfirm({
          template: 'app/views/dialogs/label-printer.html',
          className: 'ngdialog-theme-default',
          scope: dialogScope
        }).then(function () {
          $window.localStorage.setItem('printerId', dialogScope.model.printerId);
        });
      } catch (error) {
        Raven.captureException(error);
      }
    };
  }
})();
